import styled from 'styled-components'

export const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledLogoContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const StyledLogo = styled.img`
  height: 48px;
  border-radius: 8px;
`

export const StyledContentContainer = styled.article`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;

  @media(max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyledDetailImage = styled.img`
  width: 100%;
`

export const StyledSubTitleImage = styled.img`
  height: 24px;
`

export const StyledKeyFeaturesListContainer = styled.ul`
  margin: 8px 0 0;
`
